import { HostProtocol, TargetProtocol, VariableFormat } from '@iotize/tap';
import {
  BooleanConverter,
  EnumListConverter,
  FixedSizeEnumConverter,
  FloatConverter,
  Ipv4StringConverter,
  MacAddressStringConverter,
  NumberConverter,
  StringConverter,
  StringVersionConverter,
} from '@iotize/tap/client/impl';

import {
  createEnumArrayConverter,
  createEnumConverter,
} from './converter-factory';

export const ascii = StringConverter.ascii();
export const utf8 = new StringConverter('utf8');
export const uint8 = NumberConverter.uint8();
export const uint16 = NumberConverter.uint16();
export const uint32 = NumberConverter.uint32();
export const int8 = NumberConverter.int8();
export const int16 = NumberConverter.int16();
export const int32 = NumberConverter.int32();
export const float = FloatConverter.instance32();
export const boolean = BooleanConverter.instanceBit0();
export const stringIpv4 = Ipv4StringConverter.instance();
export const stringIpv4mask = Ipv4StringConverter.instance();
export const stringMacaddress = MacAddressStringConverter.instance();
export const variableFormat: FixedSizeEnumConverter<VariableFormat> =
  createEnumConverter<VariableFormat>(VariableFormat, 1);
export const hostProtocol: FixedSizeEnumConverter<HostProtocol> =
  createEnumConverter<HostProtocol>(HostProtocol, 2);
export const hostProtocolArray: EnumListConverter<HostProtocol> =
  createEnumArrayConverter<HostProtocol>(HostProtocol, 2);
export const targetProtocol: FixedSizeEnumConverter<TargetProtocol> =
  createEnumConverter<TargetProtocol>(TargetProtocol, 1);
export const targetProtocolArray: EnumListConverter<TargetProtocol> =
  createEnumArrayConverter<TargetProtocol>(TargetProtocol, 1);
// export const tapVersion = new TapVersionConverter();
export const stringVersion = new StringVersionConverter();
